module.exports = __webpack_public_path__ + "img/12.1242d9ba.jpg";